<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { CheckIsMobile } from '@/utils/mobile'
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth' // get token from cookie
import { getTeacherToken } from '@/utils/authTeacher' // get token from cookie

export default {
  name: 'App',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'name',
      'token'
    ])
  },
  async created() {
    if (getToken()) {
      if (CheckIsMobile()) {
        await this.$store.dispatch('mobile/getInfo')
      } else {
        await this.$store.dispatch('user/getInfo')
      }
    }
    if (getTeacherToken()) {
      await this.$store.dispatch('teacher/getInfo')
    }
  },
  mounted() {
  },
  methods: {
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue